module.exports = __webpack_public_path__ + "static/img/gazetaTopo1.45bf1db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/CUIABA/gazetaTopo1.png
// module id = pnxH
// module chunks = 1